import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  FaRobot,
  FaBrain,
  FaCogs,
  FaChartLine,
  FaCloud,
} from "react-icons/fa";

export default function Soft() {
  const navigate = useNavigate();

  const services = [
    {
      icon: <FaRobot />,
      title: "AI Automation",
      desc: "Automate workflows, reduce manual tasks, and boost efficiency using AI.",
    },
    {
      icon: <FaBrain />,
      title: "Machine Learning",
      desc: "Custom ML models for prediction, classification, and intelligent systems.",
    },
    {
      icon: <FaCogs />,
      title: "AI Integrations",
      desc: "Integrate AI into your apps, CRM, and business processes seamlessly.",
    },
    {
      icon: <FaChartLine />,
      title: "AI Analytics",
      desc: "Advanced insights and forecasting using data-driven AI systems.",
    },
    {
      icon: <FaCloud />,
      title: "Cloud AI Solutions",
      desc: "Deploy scalable AI systems on cloud infrastructure.",
    },
  ];

  return (
    <div className="bg-white text-gray-900 min-h-screen">
      <Header />

      {/* 🔥 HERO (AI FOCUSED) */}
      <section className="max-w-6xl mx-auto px-6 py-24 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight leading-tight">
            Build intelligent AI-powered systems
          </h1>

          <p className="mt-5 text-gray-500 max-w-xl mx-auto">
            We design and develop modern AI solutions that automate, optimize, and scale your business.
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="mt-8 px-8 py-3 bg-black text-white rounded-full font-semibold hover:opacity-80 transition"
          >
            Start AI Project
          </button>
        </motion.div>
      </section>

      {/* 💎 AI SERVICES */}
      <section className="max-w-6xl mx-auto px-6 pb-24 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <motion.div
            key={i}
            whileHover={{ y: -4 }}
            className="group p-6 rounded-2xl border border-gray-200 hover:border-gray-300 transition bg-white"
          >
            <div className="text-2xl text-gray-800 mb-4">
              {s.icon}
            </div>

            <h3 className="text-lg font-semibold mb-2">
              {s.title}
            </h3>

            <p className="text-sm text-gray-500">
              {s.desc}
            </p>

            <button
              onClick={() => navigate("/quotes")}
              className="mt-4 text-sm text-black font-medium hover:underline"
            >
              Learn more →
            </button>
          </motion.div>
        ))}
      </section>

      {/* 🚀 CTA */}
      <section className="border-t border-gray-200 py-20 text-center">
        <h2 className="text-3xl font-semibold">
          Ready to build your AI system?
        </h2>

        <button
          onClick={() => navigate("/contact")}
          className="mt-6 px-8 py-3 bg-black text-white rounded-full font-semibold hover:opacity-80 transition"
        >
          Contact Us
        </button>
      </section>

      <Footer />
    </div>
  );
}